import { useState, useEffect } from "react";
import {
  RouterProvider,
  createBrowserRouter,
  Navigate,
} from "react-router-dom";
import { CircularProgress, Box, Typography, Button } from "@mui/material";
import { initClientSide } from "./AppInitLogic";
import { isLoggedInLoader } from "./IsLoggedInLoader";
import Root from "./Root";
import HomeScreen from "./pages/home/Screens/HomeScreen";
import App from "./App";
import LogoutScreen from "./pages/Logout/LogoutScreen";
import ResetPasswordScreen from "./pages/ResetPassword/screen/ResetPasswordScreen";
import ConfirmPasswordScreen from "./pages/ResetPassword/ConfirmPasswordScreen";
import LoginScreen from "./pages/Login/screens/LoginScreen";
import PageBuildingViewScreen from "./pages/AssetManagement/PageBuilder/PageBuildingViewScreen";
import PageBuildingEditScreen from "./pages/AssetManagement/PageBuilder/PageBuilding/PageBuildingEditScreen";
import Page404 from "./components/Page404/Page403";
import AdvertisingAccountsScreen from "./pages/PaidTrafficManagement/AdvertisingAccounts/AdvertisingAccountsScreen";
import ComingSoonScreen from "./pages/ComingSoon/ComingSoonScreen";
import ETLSequenceScreen from "./pages/Admin/Processes/ETLSequences/ETLSequenceScreen";
import ETLProcessLogScreen from "./pages/Admin/Processes/ETLProcessLog/ETLProcessLogScreen";
import ETLLogLogResponseScreen from "./pages/Admin/Processes/ETLProcessLog/ETLLogLogResponseScreen";
import ETLProcessListScreen from "./pages/Admin/Processes/ETLProcessList/ETLProcessListScreen";
import PageSpeedPerformanceScreen from "./pages/AssetManagement/Health/PageSpeedPerformance/PageSpeedPerformanceScreen";
import MonitoringScreen from "./pages/AssetManagement/Health/Monitoring/MonitoringScreen";
import WebsitePageGroupScreen from "./pages/AssetManagement/WebsitePageGroup/WebsitePageGroupScreen";
import CompetitorsPageSpeedScreen from "./pages/MarketPositioning/Scout/CompetitorsPageSpeed/CompetitorsPageSpeedScreen";
import TemplatesScreen from "./pages/AssetManagement/Design/Templates/TemplatesScreen";
import CreateTemplateScreen from "./pages/AssetManagement/Design/Templates/CreateTemplateScreen";
import EditTemplateScreen from "./pages/AssetManagement/Design/Templates/EditTemplateScreen";
import EngagementIncentives from "./components/Paid Traffic/EngagementIncentives/EngagementIncentives";
import ThemeScreen from "./pages/AssetManagement/Design/Theme/ThemeScreen";
import CreateNewThemeScreen from "./pages/AssetManagement/Design/Theme/CreateNewThemeScreen";
import EditThemeScreen from "./pages/AssetManagement/Design/Theme/EditThemeScreen";
import MetaEntitiesScreen from "./pages/Admin/MetaEntities/MetaEntitiesScreen";
import WebsiteActionsScreen from "./pages/AssetManagement/WebsiteActions/WebsiteActionsScreen";
import WebsiteSettingScreen from "./pages/AssetManagement/WebsiteActions/WebsiteSettingScreen";
import WebsiteEditScreen from "./pages/AssetManagement/WebsiteActions/WebsiteEditScreen";
import BusinessLeaderDashboardScreen from "./pages/AssetManagement/Overview/BusinessLeaderDashboard/BusinessLeaderDashboardScreen";
import TrendsScreen from "./pages/AssetManagement/Overview/Trends/TrendsScreen";
import WebsiteTargetScreen from "./pages/AssetManagement/Overview/WebsiteTarget/WebsiteTargetScreen";
import NewTargetScreen from "./pages/AssetManagement/Overview/WebsiteTarget/SetWebsiteTarget/NewTargetScreen";
import EditTargetScreen from "./pages/AssetManagement/Overview/WebsiteTarget/EditWebsiteTarget/EditTargetScreen";
import DataAccuracyScreen from "./pages/AssetManagement/Health/DataAccuracy/DataAccuracyScreen";
import ActionItemsScreen from "./pages/AssetManagement/Overview/ActionItems/ActionItemsScreen";
import ActionItemAdditionalInfoScreen from "./pages/AssetManagement/Overview/ActionItems/ActionItemAdditionalInfoScreen";
import PerformanceForeCasterScreen from "./pages/AssetManagement/Overview/ForeCaster/PerformanceForeCasterScreen";
import ForeCasterInfoScreen from "./pages/AssetManagement/Overview/ForeCaster/ForeCasterInfoScreen";
import MonthlySummaryScreen from "./pages/AssetManagement/Overview/ForeCaster/MonthlySummaryScreen";
import CreateNewForeCasteScreen from "./pages/AssetManagement/Overview/ForeCaster/CreateNewForeCasteScreen";
import DuplicateForecastScreen from "./pages/AssetManagement/Overview/ForeCaster/DuplicateForecastScreen";
import DataStoreRequestScreen from "./pages/Admin/DataStoreRequest/DataStoreRequestScreen";
import DataStoreReqQueryNameScreen from "./pages/Admin/DataStoreRequest/DataStoreReqQueryNameScreen";
import DataCollectionBrandsScreen from "./pages/DataCollection/Brands/DataCollectionBrandsScreen";
import DataCollectionPackagesScreen from "./pages/DataCollection/Monitoring/DataCollectionPackagesScreen";
import DataCollectionProcesLogsScreen from "./pages/DataCollection/Monitoring/DataCollectionProcessLogsScreen";
import InsightsScreen from "./pages/AssetManagement/Overview/Insights/InsightsScreen";
import InsightAdgroupScreen from "./pages/AssetManagement/Overview/Insights/InsightAdgroupScreen";
import InsightCampaignScreen from "./pages/AssetManagement/Overview/Insights/InsightCampaignScreen";
import UniqueDefinitionsScreen from "./pages/DataCollection/Unifier/UniqueDefinitions/UniqueDefinitionsScreen";
import CreateNewDefinitionScreen from "./pages/DataCollection/Unifier/UniqueDefinitions/CreateNewDefinitionScreen";
import EditDefinitionScreen from "./pages/DataCollection/Unifier/UniqueDefinitions/EditDefinitionScreen";
import DuplicateDefinitionScreen from "./pages/DataCollection/Unifier/UniqueDefinitions/DuplicateDefinitionScreen";
import CalculationTypesScreen from "./pages/DataCollection/Unifier/CalculationTypes/CalculationTypesScreen";
import EditDataStoreRequest from "./components/Admin/DatastoreRequests/CreateAndEditDataStoreRequest/EditDataStoreRequest";
import CreateDataStoreRequest from "./components/Admin/DatastoreRequests/CreateAndEditDataStoreRequest/CreateDataStoreRequest";
import MapsScreen from "./pages/DataCollection/Unifier/Maps/MapsScreen";
import MapsInsightScreen from "./pages/DataCollection/Unifier/Maps/MapsInsightScreen";
import EditMapsScreen from "./pages/DataCollection/Unifier/Maps/EditMapsScreen";
import DuplicateMapsScreen from "./pages/DataCollection/Unifier/Maps/DuplicateMapsScreen";
import CreateMapScreen from "./pages/DataCollection/Unifier/Maps/CreateMapScreen";
import FtdLoadedFromTotalScreen from "./pages/AssetManagement/Overview/BusinessLeaderDashboard/FtdLoadedFromTotalScreen";
import FinanceManualExpenseScreen from "./pages/FinanceManagement/ProviderExpense/ManualExpenses/FinanceManualExpenseScreen";
import FinanceManualExpenseDetailScreen from "./pages/FinanceManagement/ProviderExpense/ManualExpenses/FinanceManualExpenseDetailScreen";
import TrendsBreakdownScreen from "./pages/AssetManagement/Overview/Trends/TrendsBreakdownScreen";
import BusinessActivityNotesScreen from "./pages/AssetManagement/ActivityNotes/BusinessActivityNotesScreen";
import BusinessActivityNotesDetailsScreen from "./pages/AssetManagement/ActivityNotes/BusinessActivityNotesDetailsScreen";
import LandingPageExperienceScreen from "./pages/PaidTrafficManagement/Methodology/LPExperience/LandingPageExperienceScreen";
import SingleLandingPageExpScreen from "./pages/PaidTrafficManagement/Methodology/LPExperience/SingleLandingPageExpScreen";
import DataStoreRequestRunQuery from "./components/Admin/DatastoreRequests/DataStoreRequestRunQuery/DataStoreRequestRunQuery";
import TaskNameDataAccruracyScreen from "./pages/AssetManagement/Health/DataAccuracy/TaskNameDataAccruracyScreen";
import * as Sentry from "@sentry/react";
import SearchTermOperationsScreen from "./pages/PaidTrafficManagement/Methodology/SearchTermOperations/SearchTermOperationsScreen";
import { useSelector } from "react-redux";
import {
  selectUserData,
  selectUserToken,
  setUserToken,
} from "./features/userSlice";
import { useDispatch } from "react-redux";
import { OccurrencesDataAccruracyScreen } from "./pages/AssetManagement/Health/DataAccuracy/OccurrencesDataAccruracyScreen";
import FinanceReceiptsScreen from "./pages/FinanceManagement/ProviderExpense/Receipts/FinanceReceiptsScreen";
import FinanceReceiptsPairScreen from "./pages/FinanceManagement/ProviderExpense/Receipts/FinanceReceiptsPairScreen";
import BrandConfiguration from "./components/DataCollection/BrandConfigurationReport/BrandConfigurationReport";
import BrandConfigurationReportScreen from "./pages/DataCollection/BrandConfigurationReport/BrandConfigurationReportScreen";

const AppInitializer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [initError, setInitError] = useState<string | null>(null);
  const selectUserResponse = useSelector(selectUserData)?.data;
  const dispatch = useDispatch();
  const userToken = useSelector(selectUserToken);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        setIsLoading(true);
        // let res = null;
        const token = await initClientSide((r: any) => r);
        dispatch(setUserToken(token));
        // setResponse(res);
      } catch (error) {
        console.error("App initialization failed:", error);
        Sentry.captureException(error);
        setInitError("Failed to initialize application");
      } finally {
        setIsLoading(false);
      }
    };

    initializeApp();
    // eslint-disable-next-line
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "#f5f5f5",
          gap: 3,
        }}
      >
        <CircularProgress size={60} thickness={4} color="secondary" />
        <Typography variant="h6" color="textSecondary">
          Initializing Aladdin...
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          Please wait
        </Typography>
      </Box>
    );
  }

  if (initError) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "#f5f5f5",
          gap: 2,
        }}
      >
        <Typography variant="h5" color="error">
          {initError}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Please refresh the page or contact support if the problem persists.
        </Typography>
        <Button
          variant="contained"
          onClick={() => window.location.reload()}
          sx={{ mt: 2 }}
          color="secondary"
        >
          Refresh Page
        </Button>
      </Box>
    );
  }

  // Create router after successful initialization
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Root />,
      children: [
        {
          path: "",
          element: <App />,
          loader: () => isLoggedInLoader(null),
          children: [
            {
              path: "",
              element: <HomeScreen />,
              handle: { title: "Home" },
            },
            {
              path: "*",
              element: <Navigate replace to="/" />,
            },
            {
              path: "/comingSoon",
              element: <ComingSoonScreen />,
              handle: { title: "Coming Soon" },
            },
            {
              path: "assets/page_builder/",
              element: <PageBuildingViewScreen />,
              handle: { title: "Page Builder" },
            },
            {
              path: "assets/page_builder/edit",
              element: <PageBuildingEditScreen userToken={userToken} />,
              handle: { title: "Page Builder - Edit Page" },
            },
            {
              path: "paidTraffic/:siteName?",
              element: <AdvertisingAccountsScreen userToken={userToken} />,
              handle: { title: "Advertising Accounts" },
            },
            {
              path: "finance/providers_expenses/manual_expenses",
              element: <FinanceManualExpenseScreen />,
              handle: { title: "Manual Expenses" },
            },
            {
              path: "finance/providers_expenses/manual_expenses/manual_expense_details",
              element: <FinanceManualExpenseDetailScreen />,
              handle: { title: "Manual Expense Detail" },
            },
            {
              path: "finance/providers_expenses/receipts",
              element: <FinanceReceiptsScreen />,
              handle: { title: "Receipts" },
            },
            {
              path: "finance/providers_expenses/receipts/receipts_pairing",
              element: <FinanceReceiptsPairScreen />,
              handle: { title: "Receipts Pairing" },
            },
            {
              path: "admin/:siteName?/etl-sequences",
              element: <ETLSequenceScreen userToken={userToken} />,
              handle: { title: "ETL Sequences" },
            },
            {
              path: "admin/:siteName?/etl-process-log",
              element: (
                <ETLProcessLogScreen
                  userToken={userToken}
                  response={selectUserResponse}
                />
              ),
              handle: { title: "ETL Process Log" },
            },
            {
              path: "admin/:siteName?/etl-process-list",
              element: <ETLProcessListScreen userToken={userToken} />,
              handle: { title: "ETL Process List" },
            },
            {
              path: "admin/:siteName?/etl-process-log/etl-process-log-Response",
              element: <ETLLogLogResponseScreen userToken={userToken} />,
              handle: { title: "ETL Process Log Response" },
            },
            {
              path: "assets/websites/page_groups",
              element: <WebsitePageGroupScreen userToken={userToken} />,
              handle: { title: "Page Groups" },
            },
            {
              path: "market_positioning/scout/competitors_page_speed",
              element: (
                <CompetitorsPageSpeedScreen
                  userToken={userToken}
                  response={selectUserResponse}
                />
              ),
              handle: { title: "Competitors Page Speed" },
            },
            {
              path: "assets/health/page_speed_performance/:siteName?",
              element: <PageSpeedPerformanceScreen />,
              handle: { title: "Page Speed Performance" },
            },
            {
              path: "assets/health/monitoring",
              element: <MonitoringScreen />,
              handle: { title: "Monitoring" },
            },
            {
              path: "assets/design/templates",
              element: (
                <TemplatesScreen
                  userToken={userToken}
                  response={selectUserResponse}
                />
              ),
              handle: { title: "Templates" },
            },
            {
              path: "assets/design/templates/create_new_template/",
              element: <CreateTemplateScreen />,
              handle: { title: "Create New Template" },
            },
            {
              path: "assets/design/templates/edit_new_template",
              element: <EditTemplateScreen />,
              handle: { title: "Edit Template" },
            },
            {
              path: "paidTraffic/engagement_incentives",
              element: <EngagementIncentives />,
              handle: { title: "Engagement Incentives" },
            },
            {
              path: "assets/design/theme",
              element: (
                <ThemeScreen
                  userToken={userToken}
                  response={selectUserResponse}
                />
              ),
              handle: { title: "Themes" },
            },
            {
              path: "assets/design/theme/create_new_theme",
              element: <CreateNewThemeScreen />,
              handle: { title: "Create New Theme" },
            },
            {
              path: "assets/design/theme/edit_new_theme",
              element: <EditThemeScreen />,
              handle: { title: "Edit Theme" },
            },
            {
              path: "admin/meta_entities/",
              element: <MetaEntitiesScreen userToken={userToken} />,
              handle: { title: "Meta Entities" },
            },
            {
              path: "admin/datastore_requests/",
              element: <DataStoreRequestScreen />,
              handle: { title: "Data Store Requests" },
            },
            {
              path: "admin/datastore_requests/query_view",
              element: <DataStoreReqQueryNameScreen />,
              handle: { title: "Data Store Requests" },
            },
            {
              path: "admin/datastore_requests/edit_query",
              element: <EditDataStoreRequest />,
              handle: { title: "Data Store Requests" },
            },
            {
              path: "admin/datastore_requests/create_query",
              element: <CreateDataStoreRequest />,
              handle: { title: "Data Store Requests" },
            },
            {
              path: "admin/datastore_requests/run_query",
              element: <DataStoreRequestRunQuery />,
              handle: { title: "Run Query" },
            },
            {
              path: "assets/websites/website_actions",
              element: <WebsiteActionsScreen />,
              handle: { title: "Website Actions" },
            },
            {
              path: "assets/websites/website_actions/edit_website",
              element: <WebsiteEditScreen />,
              handle: { title: "Edit Website" },
            },
            {
              path: "assets/websites/website_actions/website_setting",
              element: <WebsiteSettingScreen />,
              handle: { title: "Website Setting" },
            },
            {
              path: "assets/overview/business_leader_dashboard",
              element: (
                <BusinessLeaderDashboardScreen
                  userToken={userToken}
                  response={selectUserResponse}
                />
              ),
              handle: { title: "Business Leader Dashboard" },
            },
            {
              path: "assets/overview/business_leader_dashboard/FTD_loaded_from_total",
              element: <FtdLoadedFromTotalScreen />,
              handle: { title: "% of FTD loaded from total" },
            },
            {
              path: "assets/overview/business_leader_dashboard/QFTD_loaded_from_total",
              element: <FtdLoadedFromTotalScreen />,
              handle: { title: "% of QFTD loaded from total" },
            },
            {
              path: "assets/overview/trends/",
              element: (
                <TrendsScreen
                  userToken={userToken}
                  response={selectUserResponse}
                />
              ),
              handle: { title: "Trends" },
            },
            {
              path: "assets/overview/website_projection",
              element: <WebsiteTargetScreen userToken={userToken} />,
              handle: { title: "Website Projection" },
            },
            {
              path: "assets/overview/website_projection/set_new_projection",
              element: <NewTargetScreen userToken={userToken} />,
              handle: { title: "Set New Projection" },
            },
            {
              path: "assets/overview/website_projection/edit_projection",
              element: <EditTargetScreen userToken={userToken} />,
              handle: { title: "Edit Projection" },
            },
            {
              path: "assets/health/data_accuracy",
              element: <DataAccuracyScreen />,
              handle: { title: "Data Accuracy" },
            },
            {
              path: "assets/health/data_accuracy/task_name",
              element: <TaskNameDataAccruracyScreen />,
              handle: { title: "Task Name" },
            },
            {
              path: "assets/health/data_accuracy/task_name/occurrences",
              element: <OccurrencesDataAccruracyScreen />,
              handle: { title: "Task Name" },
            },
            {
              path: "assets/overview/action_items",
              element: <ActionItemsScreen />,
              handle: { title: "Action Items" },
            },
            {
              path: "assets/overview/action_items/edit_action_item",
              element: <ActionItemAdditionalInfoScreen />,
              handle: { title: "Edit Action Item" },
            },
            {
              path: "paidTraffic/performance_analysis/insights",
              element: <InsightsScreen />,
              handle: { title: "Aladdin - Insights" },
            },
            {
              path: "paidTraffic/performance_analysis/insights/Adgroup",
              element: <InsightAdgroupScreen />,
              handle: { title: "Aladdin - InsightsAdgroup" },
            },
            {
              path: "paidTraffic/performance_analysis/insights/Campaign",
              element: <InsightCampaignScreen />,
              handle: { title: "Aladdin - InsightsAdgroup" },
            },
            {
              path: "paidTraffic/methodology/landing_page_experience",
              element: <LandingPageExperienceScreen />,
              handle: { title: "Landing Page Experience" },
            },
            {
              path: "paidTraffic/methodology/search_term_operations",
              element: <SearchTermOperationsScreen />,
              handle: { title: "Search Term Operations" },
            },
            {
              path: "paidTraffic/methodology/landing_page_experience/analysis",
              element: <SingleLandingPageExpScreen />,
              handle: { title: "Landing Page Experience" },
            },
            {
              path: "assets/overview/activity_notes",
              element: <BusinessActivityNotesScreen />,
              handle: { title: "Business Activity Notes" },
            },
            {
              path: "assets/overview/activity_notes/activity_note_details",
              element: <BusinessActivityNotesDetailsScreen />,
              handle: { title: "Activity Note Details" },
            },
            {
              path: "assets/overview/forecaster",
              element: <PerformanceForeCasterScreen />,
              handle: { title: "Performance Forecaster" },
            },
            {
              path: "assets/overview/forecaster/Createnewforecast",
              element: <CreateNewForeCasteScreen />,
              handle: { title: "Create New Forecast" },
            },
            {
              path: "assets/overview/forecaster/forecasterInfo",
              element: <ForeCasterInfoScreen />,
              handle: { title: "Forecaster Info" },
            },
            {
              path: "assets/overview/forecaster/DuplicateForecast",
              element: <DuplicateForecastScreen />,
              handle: { title: "Duplicate Forecast" },
            },
            {
              path: "assets/overview/forecaster/forecasterInfo/MonthlySummery",
              element: <MonthlySummaryScreen />,
              handle: { title: "ForecasterInfo Monthly Summary" },
            },
            {
              path: "assets/overview/forecaster/DuplicateForecast/MonthlySummery",
              element: <MonthlySummaryScreen />,
              handle: {
                title: "Duplicate Forecast Monthly Summary",
              },
            },
            {
              path: "assets/overview/forecaster/Createnewforecast/MonthlySummery",
              element: <MonthlySummaryScreen />,
              handle: {
                title: "Create New Forecast Monthly Summary",
              },
            },
            {
              path: "data_collection/brands",
              element: <DataCollectionBrandsScreen />,
              handle: { title: "Brands" },
            },
            {
              path: "data_collection/brand_configuration_report",
              element: <BrandConfigurationReportScreen />,
              handle: { title: "Brand Configuration Report" },
            },
            {
              path: "data_collection/brands/process_logs",
              element: <BrandConfiguration />,
              handle: { title: "Brands Process Log" },
            },
            {
              path: "data_collection/monitoring/packages",
              element: <DataCollectionPackagesScreen />,
              handle: { title: "Data Collection Packages" },
            },
            {
              path: "data_collection/monitoring/process_logs",
              element: <DataCollectionProcesLogsScreen />,
              handle: { title: "Data Collection Process Logs" },
            },
            {
              path: "data_collection/unifier/unique_definitions",
              element: <UniqueDefinitionsScreen />,
              handle: { title: "Data Collection Unique Definitions" },
            },
            {
              path: "data_collection/unifier/unique_definitions/create_new_definition",
              element: <CreateNewDefinitionScreen />,
              handle: { title: "Data Collection Create Unique Definition" },
            },
            {
              path: "data_collection/unifier/unique_definitions/edit_definition",
              element: <EditDefinitionScreen />,
              handle: { title: "Data Collection Edit Unique Definition" },
            },
            {
              path: "data_collection/unifier/unique_definitions/duplicate_definition",
              element: <DuplicateDefinitionScreen />,
              handle: {
                title: "Data Collection Duplicate Unique Definition",
              },
            },
            {
              path: "data_collection/unifier/calculation_types",
              element: <CalculationTypesScreen />,
              handle: { title: "Data Collection Unifier Calculation Types" },
            },
            {
              path: "data_collection/unifier/maps",
              element: <MapsScreen />,
              handle: { title: "Data Collection Unifier Maps" },
            },
            {
              path: "data_collection/unifier/maps/insight",
              element: <MapsInsightScreen />,
              handle: { title: "Data Collection Unifier Maps Insight" },
            },
            {
              path: "data_collection/unifier/maps/edit_map",
              element: <EditMapsScreen />,
              handle: { title: "Data Collection Unifier Edit Map" },
            },
            {
              path: "data_collection/unifier/maps/duplicate_map",
              element: <DuplicateMapsScreen />,
              handle: { title: "Data Collection Unifier Duplicate Map" },
            },
            {
              path: "data_collection/unifier/maps/create_new_map",
              element: <CreateMapScreen />,
              handle: { title: "Data Collection Unifier Create New Map" },
            },
            {
              path: "/assets/overview/trends/breakdown",
              element: <TrendsBreakdownScreen />,
              handle: { title: "Trends Breakdown" },
            },
          ],
        },
        {
          path: "/login",
          element: <LoginScreen />,
          handle: { title: "Login" },
        },
        { path: "/logout", element: <LogoutScreen /> },
        { path: "/reset-password", element: <ResetPasswordScreen /> },
        {
          path: `/password/reset/confirm/:uid/:token`,
          element: <ConfirmPasswordScreen />,
        },
        {
          path: `/404`,
          element: <Page404 />,
          handle: { title: "Page 404" },
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppInitializer;
